import DialogContentComponent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DialogContentComponent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import TrackString from "../../../analytics/TrackString";
import ChapterConversationEvent from "../../../app/chapters/event/ChapterConversationEvent";
import ChapterLibrary from "../../../app/chapters/model/ChapterLibrary";
import CharacterLibrary from "../../../app/characters/model/CharacterLibrary";
import CharactersConfig from "../../../app/characters/model/CharactersConfig";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NPCModel from "../../scenario/NPCModel";
import ScenarioLibrary from "../../scenario/ScenarioLibrary";
import ScenarioPlayerEvent from "../../scenario/ScenarioPlayerEvent";
import NGTDialogFactory from "../NGTDialogFactory";
import NGTDialogPlayer from "../NGTDialogPlayer";
import DialogPlayerRegisterEvent from "./DialogPlayerRegisterEvent";
/**
 * PlayDialogCommand.js
 * 
 * Created on Oct 8, 2013, 3:36:48 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class PlayDialogCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NGTDialogFactory} dialogFactory 
     * @param {NGTDialogPlayer} dialogPlayer 
     * @param {CharactersConfig} charactersConfig 
     * @param {CharacterLibrary} characterLibrary 
     * @param {ScenarioLibrary} scenarioLibrary 
     * @param {ChapterLibrary} chapterLibrary 
     * @param {NPCModel} npcModel 
     */
    constructor(dispatcher, dialogFactory, dialogPlayer, characterLibrary, scenarioLibrary, chapterLibrary, npcModel) {
        super(dispatcher);

        this._dialogFactory = dialogFactory;
        this._dialogPlayer = dialogPlayer;
        this._characterLibrary = characterLibrary;
        this._scenarioLibrary = scenarioLibrary;
        this._chapterLibrary = chapterLibrary;
        this._npcModel = npcModel;

        this._handleContentCompletedBound = this._handleContentCompleted.bind(this);
    }

    async execute(event) {
        /** @type {DialogContentComponent} */
        const content = event.params.data.content;
        this._dialogPlayer.setContentPlayer(event.params.data.contentPlayer);
        this._dialogPlayer.setContent(content);

        const chapterId = this._chapterLibrary.getCurrentChapter().id;
        const dialogId = content.getDialogID();
        const dialog = this._dialogFactory.getDialog(dialogId);
        this._dialogPlayer.setDialog(dialogId, dialog);

        // Get the characters for the conversation.
        const definedNpcs = this._npcModel.getNPCs();
        const characters = definedNpcs.map(npc => {
            const characterId = npc.getNpcID()?.trim();
            return this._characterLibrary.getCharacterById(characterId);
        });

        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.REGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);

        // Analytics: Sends dialog start
        this.trackEvent(TrackString.EVENT_DIALOG_START, TrackString.createDialogParams(dialogId));

        this._dispatcher.addEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound, this);

        this._dialogPlayerSkin = this.openScreen(SkinKeyRegistry.CONVERSATION_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            dialogPlayer: this._dialogPlayer,
            characters,
        });

        this._startTime = Date.now();
        // this._dialogPlayer.viewContent(); // Done in conversation screen mediator after intro animation.
    }

    _handleContentCompleted({ params }) {
        if (params.data.content !== this._dialogPlayer.getContent()) {
            return;
        }

        this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);

        const dialogId = params.data.content.getDialogID();
        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.DEREGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);

        // Analytics: Sends dialog end
        this.trackEvent(TrackString.EVENT_DIALOG_END, TrackString.createDialogParams(dialogId));

        // Close the content.
        this.closeScreen(this._dialogPlayerSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        // Mark the dialog as completed.
        const dialogContent = this._dialogPlayer.getContent();
        const chapterConversationEvent = new ChapterConversationEvent(ChapterConversationEvent.COMPLETED, dialogContent.getDialogID());
        this.dispatch(chapterConversationEvent.type, { data: chapterConversationEvent });

        this.destroy();
    }

    destroy() {
        this._dialogPlayer.destroy();
        this._dialogPlayer = null;
        this._dialogPlayerSkin = null;
    }
}